export enum PageType {
  Home = 1,
  Page = 2
}
export const PageTypeOptions: { key: number, value: string }[] = [
  { key: PageType.Home, value: 'home' },
  { key: PageType.Page, value: 'page' }
];
